export const ERROR_RECEIVE = 'ERROR_RECEIVE'
export const GETUSERINFO_REQUEST = 'GETUSERINFO_REQUEST'
export const GETUSERINFO_RECEIVE = 'GETUSERINFO_RECEIVE'
export const INIT = 'INIT'